"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RtfInlinePictureExportStrategy = void 0;
var tslib_1 = require("tslib");
var rtf_export_sr_1 = require("../../../translation-table/rtf-export-sr");
var rtf_picture_export_strategy_1 = require("./rtf-picture-export-strategy");
var RtfInlinePictureExportStrategy = (function (_super) {
    tslib_1.__extends(RtfInlinePictureExportStrategy, _super);
    function RtfInlinePictureExportStrategy() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RtfInlinePictureExportStrategy.prototype.exportShapePicturePrefix = function (rtfBuilder) {
        rtfBuilder.openGroup();
        rtfBuilder.writeCommand(rtf_export_sr_1.RtfExportSR.ShapePicture);
    };
    RtfInlinePictureExportStrategy.prototype.exportShapePicturePostfix = function (rtfBuilder) {
        rtfBuilder.closeGroup();
    };
    return RtfInlinePictureExportStrategy;
}(rtf_picture_export_strategy_1.RtfPictureExportStrategy));
exports.RtfInlinePictureExportStrategy = RtfInlinePictureExportStrategy;
